import Vue from "vue";
import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;
let $download = Axios.download;

const state = {
  resultList: [],
  searchResultTotalCount: 0,
  allSelected: false
};

const getters = {
  selectedCount: state => state.resultList.filter(item => item.selected).length,
  hasSelected: state => state.resultList.some(item => item.selected)
};

const actions = {
  async fetchAll({ commit, state }, getParams) {
    let pageCount = getParams.pageCount;
    return $axios
      .get(axiosBase.getUrls().getAllProvisionalOrderList, {
        params: getParams
      })
      .then(value => {
        if (pageCount === 0) {
          commit("clearAllAreaData");
        }
        commit("appendAllAreaData", value.data.data);
        return Promise.resolve(value.data.data == null ? [] : value.data.data);
      });
  },
  async fetchOne({ commit, state }, id) {
    return $axios.get(axiosBase.getUrls().getProvisionalOrder + id).then(value => {
      return Promise.resolve(value.data.data);
    });
  },
  async postOrderApplicantRequest({ commit, state }, payload) {
    return $axios.post(axiosBase.getUrls().postProvisionalOrderApplicantRequest, payload);
  },
  async postOrderApplicantCancel({ commit, state }, payload) {
    return $axios.post(axiosBase.getUrls().postProvisionalOrderApplicantCancel, payload);
  },
  async bulkFormalOrderRequest({ commit, state }, payload) {
    return $axios.post(axiosBase.getUrls().postProvisionalOrderBulkFormal, payload).catch(reason => {
      return Promise.reject(reason.response.data);
    });
  },
  async bulkLossOrderRequest({ commit, state }, payload) {
    return $axios.post(axiosBase.getUrls().postProvisionalOrderBulkLoss, payload);
  },
  // データ出力
  async export({ commit, state }, getParams) {
    return $download.get(axiosBase.getUrls().getExportProvisionalOrder, {
      params: getParams
    });
  }
};

const mutations = {
  clearAllAreaData(state) {
    state.resultList = [];
  },
  appendAllAreaData(state, data) {
    if (data != null) {
      state.resultList = state.resultList.concat(data.list);
      state.searchResultTotalCount = data.searchResultTotalCount;
    }
  },
  updateAllSelection(state, selected) {
    state.allSelected = selected;
    state.resultList.forEach(item => {
      Vue.set(item, "selected", selected);
    });
  },
  updateItemSelection(state, { index, selected }) {
    const target = state.resultList[index];
    if (!target) return;

    Vue.set(target, "selected", selected);

    // state.allSelected = state.resultList.length > 0 && state.resultList.every(item => item.selected);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
